export interface SimpleResponse {
    body: any
    status: number
    statusText: string
    url: string
}

export class AuthenticationError extends Error {
    __proto__: AuthenticationError
    response: SimpleResponse
    constructor(response: Response, resolvedBody: any) {
        super(response.status.toString())

        // This is required to make `err instanceof AuthenticationError` work
        this.constructor = AuthenticationError
        this.__proto__ = AuthenticationError.prototype

        // 400 Bad Request - { error: "invalid_grant", errorDescription: "Invalid grant: refresh token is invalid" }
        // 400 Bad Request - { error: "invalid_grant", errorDescription: "Invalid grant: refresh token has expired" }
        this.response = {
            body: resolvedBody,
            status: response.status,
            statusText: response.statusText,
            url: response.url,
        }
    }
}
